import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import Certificates from '@/pages/centrumSzkolen/common/Certificates'
import DateAndLocation from './DateAndLocation'
import TrainingLocationMap from './TrainingLocationMap'
import Remarks from './Remarks'
import TrainingAssignedTrainersSection from './TrainingAssignedTrainersSection'
import TrainingContent from './TrainingContent'
import TrainingDetailsCard from './TrainingDetailsCard'
import TrainingProofFilesSection from './TrainingProofFilesSection'
import useTrainingDetailsPage from './hooks/useTrainingDetailsPage'

export default function TrainingDetails() {
	const { t } = useTranslation()
	const {
		addAssignedTrainer,
		assignedTrainerRows,
		certificationNames,
		certificationOptions,
		createdDate,
		loading,
		persistAssignedTrainers,
		refreshTrainersForModal,
		removeAssignedTrainer,
		statusLabel,
		training,
		uploadTrainingFile,
		downloadTrainingFile,
		deleteTrainingFile,
	} = useTrainingDetailsPage()

	if (loading) {
		return <LoadingIndicator message={t('trainings.details.loading')} />
	}

	if (!training) {
		return <div className="min-h-screen flex items-center justify-center">{t('trainings.details.noData')}</div>
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<TrainingDetailsCard
				training={training}
				statusLabel={statusLabel}
				createdDate={createdDate}
			/>

			<div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
				<DateAndLocation training={training} />
				<TrainingLocationMap training={training} />
				<TrainingContent content={training.content} />
				<Certificates certificationNames={certificationNames} />
			</div>

			<div className="mt-6">
				<TrainingAssignedTrainersSection
					training={training}
					trainerRows={assignedTrainerRows}
					certificationOptions={certificationOptions}
					onAddTrainer={addAssignedTrainer}
					onRemoveTrainer={removeAssignedTrainer}
					onRefreshTrainers={refreshTrainersForModal}
					onSaveAssignedTrainers={persistAssignedTrainers}
				/>
			</div>

			<TrainingProofFilesSection
				training={training}
				onUploadTrainingFile={uploadTrainingFile}
				onDownloadTrainingFile={downloadTrainingFile}
				onDeleteTrainingFile={deleteTrainingFile}
			/>

			<div className="mt-6">
				<Remarks remarks={training.remarks || training.uwagi} />
			</div>
		</div>
	)
}
